import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import { defineMessages, intlShape } from 'react-intl';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Downshift from 'downshift';
import { DESIGN_SYSTEM } from 'constants/icons';
import { debounce } from 'helpers/debounce';
import { calculateTextWidth, getElementFont } from 'helpers/calculateTextWidth';
import { isEmpty } from 'helpers/verify';
var CURRENT_LOCATION = 'CURRENT_LOCATION';
var DEBOUNCE_MS = 250;
var MAX_SUGGESTIONS = 5;
var messages = defineMessages({
  currentLocation: {
    id: 'locationInput.currentLocation',
    defaultMessage: 'Current location'
  }
});
export var LocationInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LocationInput, _PureComponent);

  function LocationInput(props) {
    var _this;

    _classCallCheck(this, LocationInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocationInput).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      inputElement: null,
      inputValue: '',
      isActive: false
    });

    _this.getInputValue = _this.getInputValue.bind(_assertThisInitialized(_this));
    _this.handleInputStateChange = _this.handleInputStateChange.bind(_assertThisInitialized(_this));
    _this.handleInputValueChange = _this.handleInputValueChange.bind(_assertThisInitialized(_this));

    _this.handlePageLoaded = function () {
      return _this.forceUpdate();
    };

    _this.handleSelection = _this.handleSelection.bind(_assertThisInitialized(_this));
    _this.queryPlacesDebounced = debounce(_this.props.queryPlaces, DEBOUNCE_MS);
    return _this;
  }

  _createClass(LocationInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          inputLocation = _this$props.inputLocation,
          onLoad = _this$props.onLoad;

      if (onLoad) {
        onLoad(inputLocation);
      }

      if (typeof window !== 'undefined') {
        // Needed to correctly re-calculate the input width after the page has fully loaded.
        window.addEventListener('load', this.handlePageLoaded);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          inputLocation = _this$props2.inputLocation,
          onChange = _this$props2.onChange;

      if (inputLocation !== prevProps.inputLocation) {
        onChange(inputLocation);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('load', this.handlePageLoaded);
      }
    }
  }, {
    key: "getInputWidth",
    value: function getInputWidth() {
      var style = this.props.style;
      var isActive = this.state.isActive;
      var inputValue = this.getInputValue();

      if (typeof window !== 'undefined' && this.state.inputElement && style === 'underlined' && !isActive && inputValue) {
        var inputFont = getElementFont(this.state.inputElement);
        return calculateTextWidth(inputValue, inputFont);
      }

      return null;
    }
  }, {
    key: "getIcon",
    value: function getIcon(item) {
      return item.place_id === CURRENT_LOCATION ? DESIGN_SYSTEM.currentLocation : DESIGN_SYSTEM.pin;
    }
  }, {
    key: "getInputValue",
    value: function getInputValue() {
      var _this$props3 = this.props,
          initialValue = _this$props3.initialValue,
          inputLocation = _this$props3.inputLocation;
      var _this$state = this.state,
          inputValue = _this$state.inputValue,
          isActive = _this$state.isActive; // eslint-disable-next-line no-nested-ternary

      return isActive ? inputValue : inputLocation ? inputLocation.name : initialValue;
    }
  }, {
    key: "getSuggestions",
    value: function getSuggestions() {
      var _this$props4 = this.props,
          hasDetectedLocation = _this$props4.hasDetectedLocation,
          intl = _this$props4.intl,
          placeSuggestions = _this$props4.placeSuggestions;
      return (hasDetectedLocation ? [{
        description: intl.formatMessage(messages.currentLocation),
        place_id: CURRENT_LOCATION
      }].concat(_toConsumableArray(placeSuggestions)) : placeSuggestions).slice(0, MAX_SUGGESTIONS);
    }
  }, {
    key: "handleInputStateChange",
    value: function handleInputStateChange(stateChanges) {
      if (stateChanges.isOpen === true) {
        this.setState({
          inputValue: '',
          isActive: true
        });
      }

      if (stateChanges.isOpen === false || stateChanges.type === Downshift.stateChangeTypes.blurInput) {
        this.setState({
          isActive: false
        });
      }
    }
  }, {
    key: "handleInputValueChange",
    value: function handleInputValueChange(query) {
      this.setState({
        inputValue: query
      });
      this.queryPlacesDebounced(query);
    }
  }, {
    key: "handleSelection",
    value: function handleSelection(place) {
      var _this$props5 = this.props,
          loadPlace = _this$props5.loadPlace,
          loadDetectedLocation = _this$props5.loadDetectedLocation,
          setInputSelection = _this$props5.setInputSelection;
      this.state.inputElement.blur();
      setInputSelection(place);

      if (place.place_id === CURRENT_LOCATION) {
        loadDetectedLocation();
      } else {
        loadPlace(place.place_id);
      }
    }
  }, {
    key: "itemToString",
    value: function itemToString(item) {
      return item ? item.description : '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          label = _this$props6.label,
          inputAttributes = _this$props6.inputAttributes,
          selectedItem = _this$props6.selectedItem,
          style = _this$props6.style;
      var suggestions = this.getSuggestions();
      var extraClass = style === 'underlined' ? 'location-input--underlined' : null;
      return React.createElement(Downshift, {
        inputValue: this.getInputValue(),
        itemToString: this.itemToString,
        onSelect: this.handleSelection,
        onStateChange: this.handleInputStateChange,
        onInputValueChange: this.handleInputValueChange,
        selectedItem: selectedItem
      }, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getItemProps = _ref.getItemProps,
            getLabelProps = _ref.getLabelProps,
            getMenuProps = _ref.getMenuProps,
            highlightedIndex = _ref.highlightedIndex,
            isOpen = _ref.isOpen,
            openMenu = _ref.openMenu;
        return React.createElement("div", {
          className: classNames('location-input', extraClass)
        }, label && React.createElement("label", getLabelProps(), label), React.createElement("div", {
          className: "location-input__input-wrapper"
        }, React.createElement("input", _extends({}, getInputProps(_objectSpread({}, inputAttributes, {
          onFocus: openMenu
        })), {
          autoComplete: "off",
          style: {
            width: _this2.getInputWidth()
          },
          ref: function ref(_ref2) {
            return _this2.setState({
              inputElement: _ref2
            });
          }
        })), isOpen && !isEmpty(suggestions) && React.createElement("ul", getMenuProps(), suggestions.map(function (item, index) {
          return React.createElement("li", _extends({}, getItemProps({
            key: item.place_id,
            index: index,
            item: item
          }), {
            className: classNames('location-input__item', {
              'location-input__item--highlighted': highlightedIndex === index
            })
          }), React.createElement(Isvg, {
            className: "location-input__icon",
            src: _this2.getIcon(item)
          }), item.description);
        }))));
      });
    }
  }]);

  return LocationInput;
}(PureComponent);
LocationInput.propTypes = {
  hasDetectedLocation: PropTypes.bool,
  initialValue: PropTypes.string,
  inputAttributes: PropTypes.object,
  inputLocation: PropTypes.object,
  intl: intlShape,
  label: PropTypes.node,
  loadDetectedLocation: PropTypes.func.isRequired,
  loadPlace: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onLoad: PropTypes.func,
  placeSuggestions: PropTypes.array,
  queryPlaces: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  setInputSelection: PropTypes.func.isRequired,
  style: PropTypes.oneOf(['underlined'])
};